import { sharedAtom } from '@cyberint/common-utils';

export const breadcrumbTitles = sharedAtom('breadcrumbTitles', {});
